import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Container,
  Card,
  CardActionArea,
} from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import Icon from "../../components/Icon";
import { useNavigate } from "react-router-dom";
import api from "../../globals/axios";

const useStyles = makeStyles(() => ({
  carStyle: {
    border: "1px solid #A5A5A5 !important",
  },
  cardTitle: {
    fontSize: "25px !important",
    fontStyle: "Poppins  !important",
    lineHeight: "37.5px  !important",
    marginTop: "20px !important",
  },
}));
export default function BuyerMain() {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [profileComplete, setProfileComplete] = useState(false);

  const fetchBuyerDetails = async () => {
    try {
      const result = await api.get(`/buyer/buyerdetails/`);
      console.log("Buyer details:", result.data);
      setProfileComplete(true);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        navigate("/buyer/details/");
      } else {
        console.error("Error fetching buyer details:", error);
      }
    }
  };

  useEffect(() => {
    fetchBuyerDetails();
  }, []);

  const buttons = [
    {
      label: t("View Available Commodities"),
      type: "commodities",
      route: "/buyer/view-available-commodities",
    },
    {
      label: t("Trace a Crop"),
      type: "trace",
      route: "/buyer/trace",
    },
    {
      label: t("Post a requirement"),
      type: "requirement",
      route: "/buyer/requirement",
    },
    {
      label: t("My Bids and Trades"),
      type: "trades",
      route: "/buyer/bids-trades",
    },
    {
      label: t("Programs"),
      type: "prospects",
      route: "/programs/",
    },
    {
      label: t("Decarbonization Campaign"),
      type: "Decarbonization",
      // route
    },
  ];
  return (
    <>
      {profileComplete && (
        <>
          <CustomAppBar />
          <Container maxWidth="xs">
            <Grid container spacing={2} sx={{ marginTop: "20px" }}>
              {buttons.map((button, index) => (
                <Grid
                  item
                  xs={12}
                  key={index}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Card
                    variant="outlined"
                    style={{ width: "100%", height: 162 }}
                    className={classes.carStyle}
                  >
                    <CardActionArea
                      onClick={() => navigate(button.route)}
                      style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon type={button.type} />
                      <div>
                        <Typography className={classes.cardTitle}>
                          {button.label}
                        </Typography>
                      </div>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </>
      )}
    </>
  );
}
